import React, { useState, useRef, useEffect } from "react";
import { FaChevronDown, FaTimes } from "react-icons/fa";

const MenuVisibilite = ({
  title ,
  columnLabels,
  visibleColumns,
  setVisibleColumns,
  position = "bottom", // "bottom" | "top" | "left" | "right"
  className = "",
}) => {
  const [open, setOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const menuRef = useRef(null);

  const filteredColumns = Object.entries(columnLabels).filter(([_, label]) =>
    label.toLowerCase().includes(searchText.toLowerCase())
  );

  const toggleColumn = (key) => {
    setVisibleColumns((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  // Ferme le menu si on clique à l’extérieur
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className={`menu-visibilite position-relative ${className}`} ref={menuRef}>
      {/* Bouton principal */}
      <button
        className="btn btn-light border d-flex align-items-center"
        style={{
          borderRadius: "5px",
          padding: "6px 12px",
          backgroundColor: open ? "#f8fafc" : "#fff",
          boxShadow: open ? "0 2px 6px rgba(0,0,0,0.15)" : "none",
          transition: "0.2s ease",
        }}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span>{title}</span>
        <FaChevronDown
          size={12}
          className="ms-2"
          style={{ transform: open ? "rotate(180deg)" : "rotate(0)", transition: "0.2s" }}
        />
      </button>

      {/* Contenu du menu */}
      {open && (
        <div
          className="menu-content bg-white p-3 border rounded shadow-sm"
          style={{
            position: "absolute",
            [position === "top" ? "bottom" : "top"]: "110%",
            left: 0,
            minWidth: "260px",
            zIndex: 1000,
            maxHeight: "300px",
            overflowY: "auto",
          }}
        >
          <div className="d-flex justify-content-between align-items-center mb-2">
            <strong style={{ fontSize: "14px" }}>Sélection des colonnes</strong>
            <button
              className="btn btn-sm btn-link p-0 text-muted"
              onClick={() => setOpen(false)}
            >
              <FaTimes size={14} />
            </button>
          </div>

          {/* Barre de recherche */}
          <input
            type="text"
            className="form-control form-control-sm mb-2"
            placeholder="Rechercher une colonne..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
          
          {/* ✅ Affichage conditionnel du nombre de colonnes trouvées */}
          {searchText.trim() !== "" && (
            <small className="text-muted d-block mb-2">
              {filteredColumns.length} colonne(s) trouvée(s)
            </small>
          )}

          {/* Liste des colonnes */}
          {filteredColumns.map(([columnKey, label]) => (
            <div key={columnKey} className="form-check mb-1">
              <input
                className="form-check-input"
                type="checkbox"
                id={`column-${columnKey}`}
                checked={visibleColumns[columnKey] || false}
                onChange={() => toggleColumn(columnKey)}
              />
              <label
                className="form-check-label ms-2"
                htmlFor={`column-${columnKey}`}
                style={{ cursor: "pointer", fontSize: "14px" }}
              >
                {label}
              </label>
            </div>
          ))}

          {filteredColumns.length === 0 && (
            <p className="text-muted text-center mt-3 mb-0" style={{ fontSize: "13px" }}>
              Aucune colonne trouvée
            </p>
          )}

          <div className="d-flex justify-content-between mt-3">
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => {
                const allTrue = {};
                Object.keys(columnLabels).forEach((key) => (allTrue[key] = true));
                setVisibleColumns(allTrue);
              }}
            >
              Tout sélectionner
            </button>
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={() => {
                const allFalse = {};
                Object.keys(columnLabels).forEach((key) => (allFalse[key] = false));
                setVisibleColumns(allFalse);
              }}
            >
              Tout désélectionner
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MenuVisibilite;
